'use strict';

let util = require('../core/util');

/**
 * @class AuthService
 */

module.exports = class AuthService {

    constructor(param) {
        const init = util.buildInitParam(param);

        this.EVENT_LOGGED_IN = 'auth:logged-in';
        this.EVENT_LOGGED_OUT = 'auth:logged-out';
        
        this._EventBus = init._EventBus;
        this._loginUrl = init.baseUrl + init.restPrefix + 'abc-auth/login';
        this._logoutUrl = init.baseUrl + init.restPrefix + 'abc-auth/logout';
        this._registerUrl = init.baseUrl + init.restPrefix + 'abc-auth/register';
        this._forgotPasswordUrl = init.baseUrl + init.restPrefix + 'abc-auth/forgot-password';
        this._checkIfEmailExistsUrl = init.baseUrl + init.restPrefix + 'abc-auth/check-if-unique-email';

        this._customerByPasswordTokenUrl = function(token){
            return init.baseUrl + init.restPrefix + init.abcGatewayPrefix + 'customers/password-token=' + token;
        }
        this._resetPasswordUrl = init.baseUrl + init.restPrefix + init.abcGatewayPrefix + 'customers/password/reset';
        this._changePasswordUrl = init.baseUrl + init.restPrefix + init.abcGatewayPrefix + 'customers/password';
    }

    /**
     * Register a Customer
     * @param {Object} user 
     * @param {Object} customFields 
     */
    register(user, customFields) {
        var userDetails = this._prepareRegistrationRequest(user, customFields);
        return util.makePostRequest(this._registerUrl, userDetails).then(this._dispatchIsLoggedIn.bind(this));
    }

    /**
     * Login a Customer
     * @param {Object} userDetails 
     */
    login(userDetails) {
        if(!userDetails || !util.typeOf(userDetails.email, 'string')){
            // don't have key / email
            return util.sendValidationError(new Error('Invalid login request parameter'));
        }
        return util.makePostRequest(this._loginUrl, userDetails).then(this._dispatchIsLoggedIn.bind(this));
    }

    /**
     * Logout
     */
    logout() {
        var _this = this;
        return util.makeGETRequest(this._logoutUrl).then(function(res){
            if(res.result && res.result == "success"){
                _this._EventBus.dispatch(_this.EVENT_LOGGED_OUT, res);
            }
            return res;
        });
    }

    /**
     * Initiate forgot password request
     * @param {String} customerEmail 
     * @param {String} resetPageLink 
     */
    forgotPassword(customerEmail, resetPageLink){
        return util.makePostRequest(this._forgotPasswordUrl, {
            "customerEmail": customerEmail,
            "passwordResetLink": resetPageLink,
            "passwordResetLinkPlaceholder": "password_reset_link",
            "passwordResetUsernamePlaceholder": "username",
            "sendEmailRequest": {
                "workflowName":"password-reset"
            }
        }).then(function(res){
            // simplify response
            if(util.typeOf(res, "array") && res.length){
                return res[0];
            }
            return res;
        });
    }

    /**
     * Get Customer By Password Token
     * @param {String} token 
     */
    customerByPasswordToken(token){
        return util.makeGETRequest(this._customerByPasswordTokenUrl(token));
    }

    /**
     * Reset Password by Password Token
     * @param {String} token 
     * @param {String} newPassword 
     * @param {Number} version 
     */
    resetPassword(token, newPassword, version){
        var request = {
            "tokenValue" : token,
            "newPassword": newPassword
        };
        if(util.typeOf(version, "number")){
            request.version = version;
        }
        return util.makePostRequest(this._resetPasswordUrl, request);
    }

    /**
     * 
     * @param {object} user 
     * @param {object} customFields 
     * @returns {object}
     */
    _prepareRegistrationRequest(user, customFields){
        var payload = user;
        if(payload.customerNumber == undefined){
            // request does not contain customerNumber field.
            payload.customerNumber = util.generateCustomerNumber();
        }
        if(util.typeOf(customFields, 'object')){
            // user request does not contain custom field, instead it has customFields Object
            payload.custom = {
                "type": {
                    "key": "customerCustomFields"
                },
                "fields": customFields
            };
        }
        return payload;
    }

    /**
     * Dispatch logged-in Event
     * @param {Object} res 
     */
    _dispatchIsLoggedIn(res){
        if(res.customer){
            this._EventBus.dispatch(this.EVENT_LOGGED_IN, res);
        }
        return res;
    }

    /**
     * @param customerMeta
     * @param currentPassword
     * @param newPassword
     */
    changePassword(customerMeta, currentPassword, newPassword){
        let request = {
            "id" : customerMeta.id,
            "version": customerMeta.version,
            "currentPassword": currentPassword,
            "newPassword": newPassword
        };
        return util.makePostRequest(this._changePasswordUrl, request);
    }

    /**
     * Check if email address exists
     * @param {String} email 
     */
    checkIfEmailExist(email) {
        return util.makePostRequest(this._checkIfEmailExistsUrl, {
            email: email
        });
    }
}



// WEBPACK FOOTER //
// ./src/auth/AuthService.js